<app-menu [moduloEnum]="moduloEnum" [funcionalidadeEnum]="funcionalidadeEnum"></app-menu>
<div class="container">
    <h1 class="title-default">Tintas</h1>
    <p class="welcome-message">Bem vindo ao módulo <span class="display-name">Tintas</span>! Aqui tem todos as opções de tintas</p>
    <app-lista-funcionalidade [moduloEnum]="moduloEnum"></app-lista-funcionalidade>
</div>
